import Link from "next/link";
import RocketIcon from "../components/Icons/RocketIcon";

const Error = () => {
  return (
    <div className="error-area">
      <div className="container-error">
        <div className="body">
          <div>
            <RocketIcon />
          </div>
          <div className="space-text">
            <h2>
              Error, let&apos;s go{" "}
              <Link legacyBehavior href="/">
                <a>home</a>
              </Link>
              .
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error;
